export * from './session-timeout.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/session-timeout/index.ts